import React from "react";
import styled from "styled-components";

import { SUPPLEMENTARY_FILTER_COLOURS } from "src/views/schedule/constants";

import { TSupplementaryRoles } from "../../shared/constants/roles";

/** Supplementary role colour key, shown under both schedules' calendars. */
export const ShiftLegend: React.FC = () => (
  <LegendContainer>
    {Object.values(TSupplementaryRoles).map((item) => (
      <LegendRow key={item}>
        <Dot
          color={SUPPLEMENTARY_FILTER_COLOURS[item as TSupplementaryRoles]}
        />
        <LegendText>{item}</LegendText>
      </LegendRow>
    ))}
  </LegendContainer>
);

const LegendContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px 20px;
  padding: 12px 16px;
`;

const LegendRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: none;
`;

const LegendText = styled.p`
  margin: 0 0 0 8px;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
`;

const Dot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

export default ShiftLegend;
